import axios from 'axios';
import { getTeamMember } from './getTeamMember';
import { RawTeamMember } from '../model/TeamMember';

export const getOurTeam = async (namesToExclude: string[]): Promise<RawTeamMember[]> => {
  const response = await axios.get('https://raw.githubusercontent.com/mild-blue/about/master/people/sources.json');
  const memberNames: string[] = response.data;
  const filteredMemberNames = memberNames.filter((name) => !namesToExclude.includes(name));
  const membersPromises: Promise<RawTeamMember>[] = filteredMemberNames.map((name) => getTeamMember(name));
  return await Promise.all(membersPromises);
};
